module.exports = __webpack_public_path__ + "img/commitThree.e71636e1.png";